import { z } from 'zod';

export const DeliveryArticleTagModelSchema = z.object({
    uid: z.string(),
    name: z.string(),
});

export type DeliveryArticleTagModel
= z.infer<typeof DeliveryArticleTagModelSchema>;
